import Urls from "../atoms/urls";
import { Request } from "../atoms/Utils/Request";

export const DscService = {
  getSignParams: (details = {}) =>
    Request({
      url: Urls.dsc.signParams,
      useCache: false,
      method: "POST",
      auth: true,
      userService: true,
      data: { ...details },

    })
};
